import SquaredBoxSvg408x95 from './SquaredBoxSvg408x95';

export default SquaredBoxSvg408x95;
export { SquaredBoxSvg408x95 };
